import React from "react";
import { Link, useLocation } from "react-router-dom";
import Stack from "@mui/material/Stack/Stack";
import Typography from "@mui/material/Typography/Typography";
import Button from "@mui/material/Button/Button";

/**
 * A wrong or guessed address: say so, and offer the way back (the hackathon the address was under, if any).
 */
export const PageNotFound = () => {
    const { pathname } = useLocation();
    const hackathon = pathname.match(/^\/h\/([^/]+)/)?.[1];
    return (
        <Stack direction="column" spacing={2} alignItems="center" justifyContent="center" minHeight={'60vh'} paddingTop={2} width="100%" maxWidth="420px" margin="auto" textAlign="center">
            <h1>Page not found</h1>
            <Typography color="text.secondary">There's nothing at this address. It may have moved, or the link has a typo.</Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap justifyContent="center">
                {hackathon && <Button variant="contained" component={Link} to={`/h/${hackathon}`}>Back to the hackathon</Button>}
                <Button variant={hackathon ? 'outlined' : 'contained'} component={Link} to="/">My hackathons</Button>
            </Stack>
        </Stack>
    )
}
